import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    IMLPackageVersion,
    ODataResponse,
} from '@models';
import { ODataQueryOptions } from '@services/generics/odata.query';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';

import { Observable } from 'rxjs';

@Injectable()
export class MLPackageVersionsService extends ODataService<IMLPackageVersion, string> {
    protected _endpoint = '/odata/MLPackageVersions';

    constructor(http: HttpClient) {
        super(http, MapperService.mlPackageVersionMap);
    }

    public getVersions(mlPackageVersion?: string, queryOptions?: ODataQueryOptions): Observable<ODataResponse<IMLPackageVersion>> {
        return this.get(queryOptions,
            `/odata/MLPackageVersions/UiPath.Server.Configuration.OData.GetMLPackageVersions(mlPackageId='${mlPackageVersion}')`);
    }

    public getVersionById(mlPackageId: string, mlPackageVersion?: string, queryOptions?: ODataQueryOptions)
        : Observable<ODataResponse<IMLPackageVersion>> {

        return this.get(queryOptions,
            `/odata/MLPackageVersions/UiPath.Server.Configuration.OData.GetMLPackageVersionById(
            mlPackageId='${mlPackageId}',mlPackageVersionId='${mlPackageVersion}')`);
    }
}
